import styled from "styled-components";

export const AnalyticsMenu = styled.ul`
    display: flex;
    flex: none;
    padding-top: 1em;
    list-style: none;
    font-weight: 500;
    text-decoration: none;
    padding-inline-start: 0;
`;

export const AnalyticsMenuItem = styled.li`
    margin: 8px 20px 6px 0;

    a {
        font-size: 15px;
        text-decoration: none;
        color: ${props => props.theme.foregroundBrigth};
    }

    .active {
        border-bottom: 4px solid ${props => props.theme.blueRest};
        text-decoration: none;
        padding: 15px;
        background-color: ${props => props.theme.backgroundBlackOverlay};
    }
`;
